import type { GallerySnapshot } from "@roboscientist/contracts";
import copy from "./galleryEnglishCopy.json";

const translations = new Map<string, string>(Object.entries(copy));
export const englishGalleryText = (text: string): string => translations.get(text) ?? text;

/** Translate saved display copy without changing evidence, report bodies, identifiers or files. */
export function englishGallerySnapshot(source: GallerySnapshot): GallerySnapshot {
  const title = englishGalleryText(source.snapshot.title);
  const summary = englishGalleryText(source.snapshot.summary);
  const topicTitle = englishGalleryText(source.topic.title);
  const lineageTitle = englishGalleryText(source.lineage.title);
  const experiments = source.experiments.map((experiment) => {
    const name = englishGalleryText(experiment.name);
    return name === experiment.name ? experiment : { ...experiment, name };
  });
  const lineageExperiments = source.lineage.experiments.map((experiment) => {
    const title = englishGalleryText(experiment.title);
    return title === experiment.title ? experiment : { ...experiment, title };
  });
  return {
    ...source,
    snapshot: { ...source.snapshot, title, summary },
    topic: { ...source.topic, title: topicTitle },
    lineage: { ...source.lineage, title: lineageTitle, experiments: lineageExperiments },
    experiments
  };
}
